import {Directive, ElementRef, HostListener} from '@angular/core';
import {Hotkeys} from './hotkeys.enum';
import {HotkeysService} from './hotkeys.service';

@Directive({
  selector: '[ggHotkeys]'
})
export class HotkeysDirective {
  private keys = {};

  constructor(private el: ElementRef, private hotkeyService: HotkeysService) {
    this.el.nativeElement.setAttribute('tabindex', '0');

    this.prepareKeys();
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const bind = this.getBindForKey(event);

    if (bind) {
      this.hotkeyService.emit(bind);
    }
  }

  @HostListener('dblclick', ['$event']) onDblClick(event: MouseEvent) {
    if (this.ignoreDblClick(event.target)) {
      return;
    }
    this.hotkeyService.emit('toggleFullscreen');
  }

  private prepareKeys() {
    for (let key in Hotkeys) {
      let prepared = Hotkeys[key].toLowerCase().split(',').map(k => k.trim().split('+').sort().join('+'));
      prepared.forEach(k => this.keys[k] = key);
    }
  }


  private getBindForKey(event: KeyboardEvent) {
    let key = [event.code.replace('Key', '').toLocaleLowerCase()];
    let modifiers = ['ctrl', 'alt', 'shift', 'meta'];

    key.push(...modifiers.filter(m => event[m + 'Key']));

    console.log({key: key.sort().join('+')});

    return this.keys[key.sort().join('+')];
  }

  private ignoreDblClick(target: any) {
    const ignore = ['gg-play-btn', 'gg-volume-bar', 'gg-fullscreen-btn', 'gg-popup-btn', 'gg-create-clip'];

    for (const selector of ignore) {
      if (target.closest(selector)) {
        return true;
      }
    }

    return false;
  }
}

